const blockAccordion = () => {
  document.addEventListener("DOMContentLoaded", function () {
    function getHeaderHeight() {
      var header = document.querySelector(".header");
      var adminBar = document.getElementById("wpadminbar");
      var h = 0;

      if (header) {
        h += header.getBoundingClientRect().height;
      }
      if (adminBar && window.getComputedStyle(adminBar).display !== "none") {
        h += adminBar.getBoundingClientRect().height;
      }

      return h;
    }

    function openAccordionIfNeeded(target, callback) {
      // Cerca il li dell’accordion che contiene il target
      var accordionItem = target.closest(".block-accordion-image__item, .accordion-item");
      if (!accordionItem) {
        // Non è dentro un accordion ➜ scrolla subito
        if (typeof callback === "function") callback();
        return;
      }

      var collapse = accordionItem.querySelector(".accordion-collapse");
      if (!collapse) {
        if (typeof callback === "function") callback();
        return;
      }

      // Se è già aperto non serve aspettare l'evento
      if (collapse.classList.contains("show")) {
        if (typeof callback === "function") callback();
        return;
      }

      // Usa Bootstrap 5 Collapse
      var bsCollapse = Collapse.getOrCreateInstance(collapse, { toggle: false });

      // Quando l’accordion è completamente aperto, esegui lo scroll
      var onShown = function () {
        collapse.removeEventListener("shown.bs.collapse", onShown);
        if (typeof callback === "function") callback();
      };
      collapse.addEventListener("shown.bs.collapse", onShown);

      bsCollapse.show();
    }

    function scrollToAnchor(hash, updateHash) {
      if (!hash) return;
      var id = hash.replace("#", "");
      if (!id) return;

      var target = document.getElementById(id);
      if (!target) return;

      // Funzione che effettua effettivamente lo scroll, una volta che
      // eventuali accordion sono aperti e l’header si è assestato
      function doScroll() {
        // Recalcola ogni volta: l’header può cambiare dimensione con lo scroll
        var headerHeight = getHeaderHeight();
        var rect = target.getBoundingClientRect();
        var offset = window.pageYOffset + rect.top - headerHeight - 16; // 16px di margine

        if (offset < 0) offset = 0;

        window.scrollTo({
          top: offset,
          behavior: "smooth",
        });

        if (updateHash) {
          // Evita di triggherare di nuovo hashchange
          history.replaceState(null, "", "#" + id);
        }
      }

      // Se è dentro un accordion, aprilo e poi fai lo scroll
      openAccordionIfNeeded(target, doScroll);
    }

    // Gestione caricamento iniziale con #ancora nell’URL
    if (window.location.hash) {
      // Piccolo delay per sovrascrivere lo scroll di default del browser
      setTimeout(function () {
        scrollToAnchor(window.location.hash, false);
      }, 50);
    }

    // Gestione cambi hash da URL (es. utente modifica manualmente o link esterno)
    window.addEventListener("hashchange", function () {
      scrollToAnchor(window.location.hash, false);
    });

    // Smooth scroll + apertura accordion per i link interni alla stessa pagina
    document.querySelectorAll('a[href*="#"]').forEach(function (link) {
      try {
        var url = new URL(link.href);
        // Considera solo gli anchor della stessa pagina
        if (url.pathname !== window.location.pathname) return;
        if (!url.hash) return;

        link.addEventListener("click", function (e) {
          // Lascia lavorare solo il nostro scroll, non quello di default
          e.preventDefault();
          scrollToAnchor(url.hash, true);
        });
      } catch (err) {
        // In caso di URL relativi strani, ignora
      }
    });
  });
};
export default blockAccordion;
